module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"archived":"Archived","reviewed":"Checked","cons":"{0} cons","pros":"{0} pros"}}')
  delete Component.options._Ctor
}
